import {isValidPhoneNumber} from "libphonenumber-js";
import Vuelidate from 'vuelidate'
import {email, minLength, required} from 'vuelidate/lib/validators'
import Notifications from "vt-notifications";

const Vue = require('vue').default;
const axios = require('axios').default;
let cancelTokenSource = axios.CancelToken.source();
let projectRequest, mapRequest;

Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.use(require('vue-cookies'))

const phoneNumber = function (value) {
  return value && isValidPhoneNumber(value, 'NL');
}
const fileSizeValidation = (value, vm) => {
  if (!value) {
    return true;
  }
  return (value.size < 4096000);
};

const DakkapelApp = new Vue({
      el: '#dakkapel-nl',
      data: {
        loading: false,
        showUrgentNotification: false,
        showModal: false,
        showSidebar: false,
        jobConversionUrl: '',
        sent: false,
        submitting: false,
        sidebarContent: '',
        sidebarPrev: false,
        sidebarNext: false,
        sidebarcloseText: '&larr;	Sluiten',
        faqItem: null,
        selectedMode: 'gallery',
        filterMaterial: '',
        filterWidth: '',
        locationSearch: window.localStorage.getItem('location_formatted'),
        browserOpen: false,
        mapsApiReady: false,
        miniProjects: [],
        noCaptchaForms: [],
        recaptchaLoaded: false,
        jobForm: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          terms: false,
          job_title: '',
          job_url: '',
          resume: null
        },
      },
      validations: {
        jobForm: {
          first_name: {
            required,
            minLength: minLength(2)
          },
          last_name: {
            required,
            minLength: minLength(2)
          },
          email: {
            required,
            email
          },
          job_title: {
            required,
          },
          job_url: {
            required,
          },
          phone: {
            required,
            phoneNumber
          },
          terms: {
            required
          },
          resume: {
            fileSizeValidation
          }
        }
      },

      components: {
        'modal': () => import('./vue/Modal'),
        'toast': () => import('./vue/Notification'),
        'dk-project': () => import('./vue/Plaatsing'),
      },
      beforeMount() {
        this.jobConversionUrl = this.$el.querySelector('[id="jobOverview"]')?.dataset.jobThanksUrl;
      },
      mounted: function () {
        if (this.$el.getAttribute('data-default-faq')) {
          this.faqItem = this.$el.getAttribute('data-default-faq');
        }

        let tempMode = new URLSearchParams(window.location.search).get('mode');
        if (tempMode && tempMode === 'map') {
          this.selectedMode = 'map';
        } else if (tempMode && tempMode === 'gallery') {
          this.selectedMode = 'gallery';
        }

        let self = this
        $('body').on('keydown', function (e) {
          if (e.which === 27) {
            self.closeSidebar();
          }
        });

        this.recaptchaWatch()


      },
      watch: {
        showSidebar: function (newValue, oldValue) {
          if (newValue === true) {
            $('body').addClass('overflow-hidden')
          } else {
            $('body').removeClass('overflow-hidden')
          }
        },
        // faqItem: function (newValue, oldValue) {
        //   let self = this;
        //   const url = new URL(window.location.href);
        //   url.pathname = newValue;
        //   self.pushUrl(url);
        // },
        selectedMode: function (newValue, oldValue) {
          let self = this;
          const url = new URL(window.location.href);
          url.searchParams.set('mode', newValue);
          self.pushUrl(url);

          if (this.selectedMode === 'map') {
            self.delayedBootMaps();
          }
        },
        locationSearch: function (newValue, oldValue) {
          if (window.localStorage) {
            window.localStorage.setItem('location_search', newValue);
          }
        }
      },
      methods: {
        dismissUrgentNotification: function () {
          this.$cookies.set('urgentNotificationDismissed', true);
          this.showUrgentNotification = false;
        },
        pushUrl: function (url) {
          if (window.history) {
            window.history.pushState(null, document.title, url.toString());
          }
        },
        navigate: function (url) {
          window.location = url;
        },
        loadProject: function (url) {
          this.loadSidebar(url, '&larr;	Sluiten')
        },

        populateSidebar: function (html, closeText, next, prev) {
          if (closeText) {
            this.sidebarcloseText = closeText;
          } else {
            this.sidebarcloseText = null;
          }

          this.sidebarContent = html;
          this.sidebarNext = next;
          this.sidebarPrev = prev;
          this.showSidebar = true;
        },

        loadSidebar: function (url, closeText) {
          this.loading = true;
          projectRequest = axios
              .get(url, {
                cancelToken: cancelTokenSource.token,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
              })
              .then(response => {
                this.populateSidebar(response.data.html, closeText, response.data.next, response.data.prev);
              })
              .catch(error => {
                //console.log(error)
              })
              .then(() => {
                window.setTimeout(() => {
                  this.loading = false
                }, 250)

              })
        },

        closeSidebar: function () {
          this.showSidebar = false;
          this.sidebarContent = '';
        },

        mapReady: function () {
          this.mapsApiReady = true;
          this.bootMaps();
        },

        /**
         * Alpine/vue will trigger the method too early, when the map DOM-element is not visible yet in jQuery,
         * therefore we will delay this request
         */
        delayedBootMaps: function () {
          let self = this;
          window.setTimeout(function () {
            self.bootMaps();
          }, 200);
        },

        bootMaps: function () {
          if (this.mapsApiReady) {
            GoogleMap.boot();
          }
        },

        loadMapResults: function (formData) {
          let self = this
          let formArray = Core.getArrayFromFormData(formData);
          if (formArray.length === 1) {
            self.loadSingleHtml(formData)
          } else {
            self.loadMultiple(formData)
          }
        },

        loadSingleHtml: function (formData) {
          let self = this
          let endpoint = $('#locationComplete').closest('form').data('single');
          this.loading = true;

          mapRequest = axios
              .post(endpoint, formData, {
                cancelToken: cancelTokenSource.token,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
              })
              .then(response => {
                self.populateSidebar(response.data.html, '&larr;	Sluiten', false, false);
              })
              .catch(error => {
                //console.log(error)
              })
              .then(() => {
                window.setTimeout(() => {
                  this.loading = false
                }, 250)
              });
        },

        loadMultiple: function (formData) {
          let self = this;
          let endpoint = $('#locationComplete').closest('form').data('action');
          this.loading = true;

          mapRequest = axios
              .post(endpoint, formData, {
                cancelToken: cancelTokenSource.token,
                headers: {'X-Requested-With': 'XMLHttpRequest'}
              })
              .then(response => {
                self.openSliderBoxFromJson(response.data)
              })
              .catch(error => {
                //console.log(error)
              })
              .then(() => {
                window.setTimeout(() => {
                  this.loading = false
                }, 250)
              });
        },

        openSliderBoxFromJson: function (items) {
          let self = this
          $('.search-results-browser .slick-initialized').slick('unslick')
          $('.search-results-browser').removeClass('has-nav').addClass('hidden')

          this.miniProjects = items
          window.setTimeout(function () {

            let $slickElement = $('.search-results-browser .search-results-slider:not(.slick-initialized)')
            $slickElement.data('multiple-xs', 2)
            $slickElement.data('multiple-md', 4)
            $slickElement.data('multiple-lg', 4)

            $('.search-results-browser').addClass('has-nav')
            $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
              let i = (currentSlide ? currentSlide : 0) + 1
              $('.carousel-dots').text(i + ' / ' + slick.slideCount)
            })

            $slickElement.on('init reInit', function (slick) {
              $('.search-results-browser').removeClass('hidden')
            })

            let sliderOptions = Core.slickOptions($slickElement);
            sliderOptions.appendArrows = $('.carousel-arrows');

            $slickElement.slick(sliderOptions)
            self.browserOpen = true;
          }, 500)

        },

        /**
         * Open the slideBox based on html we get from the backend
         * @param html
         */
        openRenderedSliderBox: function (html) {
          // destroy old sliders
          $('.search-results-browser .slick-initialized').slick('unslick')
          $('.search-results-browser .search-results-slider').remove()
          $('.search-results-browser').removeClass('has-nav').addClass('hidden')

          // add slider div
          $('<div class="search-results-slider margin-slides" />').prependTo('.search-results-browser')

          // add divs to slider
          $('.search-results-browser .search-results-slider').html(html)

          let $slickElement = $('.search-results-browser .search-results-slider:not(.slick-initialized)')
          $slickElement.data('multiple-xs', 2)
          $slickElement.data('multiple-md', 4)
          $slickElement.data('multiple-lg', 4)

          $('.search-results-browser').addClass('has-nav')
          $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            let i = (currentSlide ? currentSlide : 0) + 1
            $('.carousel-dots').text(i + ' / ' + slick.slideCount)
          })

          $slickElement.on('init reInit', function (slick) {
            $('.search-results-browser').removeClass('hidden')
          })

          let sliderOptions = Core.slickOptions($slickElement);
          sliderOptions.appendArrows = $('.carousel-arrows');
          $slickElement.slick(sliderOptions)

        },

        closeSliderBox: function () {
          $('.search-results-browser').addClass('hidden')
        },

        handleResumeUpload: function () {
          if (this.$refs.resume && typeof this.$refs.resume.files === 'object') {
            this.jobForm.resume = this.$refs.resume.files[0];
          }
        },

        jobApplication: function (jobTitle, jobUrl) {
          this.jobForm.job_title = jobTitle;
          this.jobForm.job_url = jobUrl;
          this.showModal = true
        },

        checkJobForm: function () {
          this.$v.$touch()
          if (this.$v.$invalid) {
            this.$notify(
                {
                  group: "default",
                  title: "Formulier bevat fouten",
                  text: "Controleer de velden en probeer het opnieuw",
                  type: 'error'
                },
                5000
            );
          } else {
            this.sendJobForm();
          }
        },

        sendJobForm: function () {
          this.submitting = true;
          let self = this;
          let formData = Core.getFormDataFromArray(this.jobForm)
          if (this.jobForm.resume) {
            formData.append('resume', this.jobForm.resume)
          }

          axios.post('/api/jobApplication', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
              .then(response => {
                if (response.data.success) {
                  this.sent = true;
                  self.$notify(
                      {
                        group: "default",
                        title: "Sollicitatie verzonden!",
                        text: "We hebben je sollicitatie ontvangen en nemen z.s.m. contact met je op.",
                        type: 'info'
                      },
                      5000
                  );

                  window.location = this.jobConversionUrl;

                } else {
                  self.$notify(
                      {
                        group: "default",
                        title: "Er ging iets fout",
                        text: "Probeer het nog eens",
                        type: 'error'
                      },
                      5000
                  );
                }
              })
              .catch((error) => {
                if (typeof error.response.data.errors === 'object') {
                  error.response.data.errors.forEach(function (errorMessage, index) {
                    self.$notify(
                        {
                          group: "default",
                          title: "Fout opgetreden",
                          text: errorMessage,
                          type: 'error'
                        },
                        5000
                    );
                  })
                }
              }).finally(() => {
            this.submitting = false;
          });
        },
        recaptchaInitialize: function (forms) {
          let self = this
          const render = function (form) {
            //For the invisible captcha we need to setup some callback listeners
            var superHandler = false;

            if (typeof jQuery != 'undefined' && typeof jQuery.fn.validate != 'undefined') {
              var formValidator = jQuery(form).data('validator');
              if (!formValidator) {
                formValidator = jQuery(form).validate();
              }

              var superHandler = formValidator.settings.submitHandler;
              formValidator.settings.submitHandler = function (form) {
                formValidator.cancelSubmit = true;

                var input = document.getElementById('Nocaptcha-' + form.getAttribute('id'));
                grecaptcha.execute(input.getAttribute('data-sitekey'), {action: 'submit'}).then(function (token) {
                  input.value = token;

                  if (superHandler) {
                    superHandler(form);
                  } else {
                    jQuery(form).unbind('submit').submit();
                  }
                });
              };
            } else {
              var submitListener = function(e) {
                e.preventDefault();

                var input = document.getElementById('Nocaptcha-' + form.getAttribute('id'));
                grecaptcha.execute(input.getAttribute('data-sitekey'), {action: 'submit'}).then(function (token) {
                  if (form && form.addEventListener) {
                    form.removeEventListener('submit', submitListener);
                  } else if (form && form.attachEvent) {
                    window.detachEvent('onsubmit', submitListener);
                  }

                  input.value = token;

                  form.submit();
                });
              };

              if (form && form.addEventListener) {
                form.addEventListener('submit', submitListener);
              } else if (form && form.attachEvent) {
                window.attachEvent('onsubmit', submitListener);
              } else if (console.error) {
                console.error('Could not attach event to the form');
              }
            }
          }

          if (self.noCaptchaForms.length > 0) {
            for (let i = 0; i < self.noCaptchaForms.length; i++) {
              render(document.getElementById(self.noCaptchaForms[i]));
            }
          }
        },

        recaptchaLoad: function () {
          var head = document.getElementsByTagName('body')[0];
          var script = document.createElement('script');
          script.type = 'text/javascript';
          // script.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaInitialize&render=explicit';
          let _recaptchaSiteKey = recaptchaSiteKey || '';
          script.src = 'https://www.google.com/recaptcha/api.js?render='+_recaptchaSiteKey+'&onload=recaptchaInitialize';
          head.appendChild(script);
        },

        recaptchaWatch: function () {
          let self = this
          if (self.noCaptchaForms.length > 0) {
            for (let i = 0; i < self.noCaptchaForms.length; i++) {
              $('#' + self.noCaptchaForms[i] + ' input:text').on('focus change', function (e) {
                if (!self.recaptchaLoaded) {
                  self.recaptchaLoaded = true
                  self.recaptchaLoad()
                }
              })
            }
          }
        }
      },

      created() {
        //this.showUrgentNotification = !this.$cookies.get('urgentNotificationDismissed');
        if (typeof _noCaptchaForms !== 'undefined') {
          this.noCaptchaForms = _noCaptchaForms
        }
      }
    })
;

export default DakkapelApp;
